var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6011 10.2281C19.6017 9.54224 19.541 8.85768 19.4197 8.18262H10V12.0506H15.382C15.2709 12.6626 15.0368 13.2456 14.6938 13.7645C14.3508 14.2833 13.9061 14.7272 13.3865 15.0691V17.5787H16.6185C18.5095 15.8371 19.6006 13.2736 19.6006 10.2281H19.6011Z",
    fill: "#3E82F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 19.9999C12.7 19.9999 14.964 19.1044 16.6185 17.5774L13.3865 15.0679C12.491 15.6679 11.3455 16.0229 9.99999 16.0229C7.3955 16.0229 5.19044 14.2639 4.40449 11.8999H1.06348V14.4943C1.8965 16.15 3.17329 17.5416 4.75132 18.5138C6.32935 19.486 8.14652 20.0005 9.99999 19.9999Z",
    fill: "#32A753"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40503 11.9008C3.9863 10.6687 3.9863 9.33284 4.40503 8.10078V5.50977H1.06346C0.364155 6.90366 0 8.44158 0 10.0011C0 11.5605 0.364155 13.0985 1.06346 14.4923L4.40503 11.9008Z",
    fill: "#F9BB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06348 5.50955L4.40505 8.10056C5.19157 5.73652 7.39606 3.97753 10.0006 3.97753C11.4691 3.97753 12.7871 4.48315 13.8236 5.47303L16.6921 2.60449C14.9601 0.991012 12.6966 6.14178e-07 9.99999 6.14178e-07C8.14603 -0.000649154 6.32841 0.514278 4.75027 1.48724C3.17213 2.46019 1.89564 3.85284 1.06348 5.50955Z",
    fill: "#E74133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.326215d2dfa4e33b3bbcbc34bfa26cfc.svg";
export { ForwardRef as ReactComponent };